export const createClasses = (...classNames: (string | undefined | null)[]) =>
  classNames.filter((name) => Boolean(name)).join(' ')
